import { SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAILED } from '../actions/feedbackForm';

export default (apiRequest, endpoints) => {

    return {
        [SEND_FEEDBACK]: sendFeedback
    }

    function sendFeedback(action, store) {
        if (!action.data) {
            return;
        }
        const { 
            feedbackType = null,
            feedbackText = null,
            feedbackRating = null,
            feedbackRecaptcha = null,
            currentUrl = null,
            userAgent = null,
            username = null // optional if logged in
        } = action.data;

        const { common:{ userService: { feedback: feedbackEndpoint = '' } = {} } = {} } = endpoints;

        if (![feedbackType, feedbackText, feedbackRating,feedbackRecaptcha, currentUrl, userAgent].includes(null) && feedbackEndpoint) {
            let requestBody = {
                current_url: currentUrl,
                feedback: feedbackText,
                feedback_score: feedbackRating,
                feedback_type: feedbackType,
                user_agent: userAgent,
            }
            if (username) {
                requestBody["username"] = username;
            }

            apiRequest("POST", feedbackEndpoint, {recaptchatoken: feedbackRecaptcha}, requestBody)
            .then(() => {
                store.dispatch({type: SEND_FEEDBACK_SUCCESS});
            })
            .catch(() => {
                store.dispatch({type: SEND_FEEDBACK_FAILED});
            })

        } else {
            store.dispatch({type: SEND_FEEDBACK_FAILED});
        }
    }
}



// WEBPACK FOOTER //
// ./modules/Common/apiRequestHandler/feedbackRequest.js